
import { Component, Vue } from 'vue-property-decorator';
import { deleteStayCancelPolicy, getStayCancelPolicyList } from '@/api/stayCancelPolicy';
import { getStayList, updateRefundPolicyInfo } from '@/api/stay';
import StayCancelPolicyForm from './components/form.vue';

@Component({
  components: {
    StayCancelPolicyForm,
  },
})
export default class extends Vue {
  mounted() {
    this.getList();
    this.getStay();
  }

  private loading = true;

  private cancelPolicyList: any = [];

  private selectedIdx: any = null;

  private formVisible = false;

  private getList() {
    this.loading = true;
    getStayCancelPolicyList().then((res) => {
      this.cancelPolicyList = res.data;
      this.loading = false;
    });
  }

  private getStay() {
    this.loading = true;
    getStayList().then((res) => {
      if (res.data.length > 0) {
        this.form = {
          ...this.form,
          ...res.data[0],
        };
        this.loading = false;
      }
    });
  }

  private handleDelete(item: any) {
    this.$confirm('정말 환불 규정을 삭제하시겠습니까?', '환불 규정 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'error',
    }).then(() => {
      deleteStayCancelPolicy(item.idx).then(() => {
        this.getList();
        this.$message.success('환불 규정이 삭제되었습니다.');
      });
    });
  }

  private handleVisibleForm(idx: any) {
    this.selectedIdx = idx;
    this.formVisible = !this.formVisible;
  }

  private handleSaveForm() {
    this.handleVisibleForm(null);
    this.getList();
  }

  private handleSaveRefundPolicy() {
    updateRefundPolicyInfo(this.form.idx, this.form).then(() => {
      this.$message.success('숙소정보 (취소 및 환불규정)이 저장되었습니다.');
      this.getStay();
    });
  }

  private form: any = {
    idx: '',
    refundPolicyInfo: '',
  }

  private placeholderTemplate: any = {
    refundPolicyInfo: '* 환불 안내(낮 12시 기준)\n\n취소는 아래 위약금 공제 후 환불됩니다. 신중히 결정하고 예약해주십시오.\n1. 이용 7일 전 : 10% 위약금\n2. 이용 6일 전 : 15% 위약금\n3. 이용 5일 전 : 20% 위약금\n4. 이용 4일 전 : 30% 위약금\n5. 이용 3일 전 : 50% 위약금\n6. 이용 2일 전 : 70% 위약금\n7. 이용 1일 전 ~ 당일 : 100% 위약금',
  }
}
